module.exports = __webpack_public_path__ + "static/media/conditioning_protocol_opening.f522495c.mp3";